var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.isAuthenticated)?_c('div',{staticClass:"fixed z-10 bottom-0 inset-x-0 mb-6 mx-6"},[_c('transition-fade',[_c('alert-warning',{directives:[{name:"show",rawName:"v-show",value:(_vm.isVisible),expression:"isVisible"}]},[_vm._v(" "+_vm._s(_vm.text)+" ")])],1)],1):_c('modal-auto-logout-info')
}
var staticRenderFns = []

export { render, staticRenderFns }